@let selectedOption = options() && options()[selectedOptionIndex()];
@let selectedOptionLabel = selectedOption && selectedOption[optionLabelName()];

@if (label()) {
  <label class="label">{{ label() }}</label>
}

<div class="dropdown" [attr.data-size]="size()" [attr.data-style]="style()">
  <!-- DropDown Button -->
  <button
    #trigger
    type="button"
    class="dropdown__button"
    [cdkMenuTriggerFor]="menu"
    [disabled]="isDisabled()"
    (cdkMenuOpened)="onMenuOpen()"
    (cdkMenuClosed)="onMenuClose()"
  >
    <span
      class="dropdown__button_name"
      [ngClass]="{ placeholder: !selectedOptionLabel }"
    >
      @if (icon()) {
        <i class="dropdown__button_name_icon icon" [ngClass]="icon()"></i>
      }
      {{ selectedOptionLabel || placeholder() }}
    </span>

    @if (
      showOptionPrice() &&
      selectedOption &&
      selectedOption[optionPriceName()] !== undefined &&
      selectedOption[optionPriceName()] !== null &&
      selectedOption[optionPriceName()] !== 0 &&
      selectedOption[optionPriceName()] !== ''
    ) {
      <span class="dropdown__button_price">
        +{{
          selectedOption[optionPriceName()]
            | currency:
                optionPriceCurrencyCode():
                optionPriceDisplay():
                optionPriceDigitsInfo()
        }}
      </span>
    }

    <i
      class="dropdown__button_icon icon icon-chevron-down"
      [ngClass]="{ opened: isOpen() }"
    ></i>
  </button>

  <!-- DropDown Options -->
  <ng-template #menu>
    <div
      cdkMenu
      class="dropdown__options"
      [attr.data-size]="size()"
      [attr.data-style]="style()"
      [style.min-width.px]="trigger.offsetWidth"
    >
      <ul class="dropdown__options-list">
        @let activeBackgroundColor = getActiveBackgroundColor();
        @let activeContrastColor = getContrastColor(activeBackgroundColor);
        @for (option of options(); track $index) {
          @let isActive = selectedOptionIndex() === $index;

          <li
            cdkMenuItem
            class="dropdown__options-list_item option"
            [ngClass]="{ active: isActive }"
            [style.backgroundColor]="isActive ? activeBackgroundColor : null"
            [style.color]="isActive ? activeContrastColor : null"
            (cdkMenuItemTriggered)="onSelectOption($index)"
          >
            <span class="dropdown__options-list_item_label">
              {{ option[optionLabelName()] }}
            </span>

            @if (
              showOptionPrice() && 
              option[optionPriceName()] !== undefined &&
              option[optionPriceName()] !== null &&
              option[optionPriceName()] !== 0 &&
              option[optionPriceName()] !== ''
            ) {
              <span class="dropdown__options-list_item_price">
                +{{
                  option[optionPriceName()]
                    | currency:
                        optionPriceCurrencyCode():
                        optionPriceDisplay():
                        optionPriceDigitsInfo()
                }}
              </span>
            }
          </li>
        } @empty {
          <li class="dropdown__options-list_item empty">{{ empty() }}</li>
        }
      </ul>
    </div>
  </ng-template>
</div>
